import juriApi from "./juriApi";

/**
 * Request (or retrieve cached) an AI summary for a court order.
 * POST /api/case/orders/summary
 * @param {{ orderId: string, orderLink?: string, pdfProxyUrl?: string, pdfStorageUrl?: string }} data
 * @returns {Promise<{ jobId: string, status: string, summary?: string }>}
 */
export const requestOrderSummary = (data) =>
  juriApi.post("/api/case/orders/summary", data).then((r) => r.data);

/**
 * Poll the status of an order-summary job.
 * GET /api/case/orders/summary/{jobId}
 * @param {string} jobId
 * @returns {Promise<{ status: string, summary?: string, failureReason?: string }>}
 */
export const getOrderSummaryStatus = (jobId) =>
  juriApi.get(`/api/case/orders/summary/${jobId}`).then((r) => r.data);

export const requestSummarizeAll = (data) =>
  juriApi.post("/api/case/orders/summary-all", data).then((r) => r.data);

export const getSummarizeAllStatus = (jobId) =>
  juriApi.get(`/api/case/orders/summary-all/${jobId}`).then((r) => r.data);
